import styled from 'styled-components'
import { media } from '../../layouts/utils'
import { colorBrandPrimary, fontFamily } from '../../global.style'

export const TituloH1 = styled.h1`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.brand};
    font-size: ${(props) =>
        props.tamanho === 'Grande' || props.tamanho === 'Grande (padrão)'
            ? '48px'
            : '32px'};
    font-weight: normal;
    letter-spacing: 0;
    line-height: 70.4px;
    text-align: center;
    padding-top: 20px;
    padding-left: ${({ containerPadding }) => (containerPadding ? '24px' : '')};
    padding-right: ${({ containerPadding }) =>
        containerPadding ? '24px' : ''};

    ${media.phone`
        padding-bottom: 0px;
        font-size: ${({ length }) => (length === 2 ? '24px' : '24px')};
        line-height: 28px;
        margin-bottom: 5px;
        width: ${({ length }) => (length === 2 ? '272px' : '100%')};
        line-height: ${({ length }) => (length === 2 ? '31.2px' : '72.4px%')};
    `}
`

export const Titulo = styled.h2`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.brand};
    font-size: ${(props) =>
        props.tamanho === 'Grande' || props.tamanho === 'Grande (padrão)'
            ? '48px'
            : props.tamanho === 'Médio'
            ? '32px'
            : '24px'};
    font-weight: normal;
    letter-spacing: 0;
    line-height: 72.4px;
    text-align: center;
    padding-top: 20px;
    padding-left: ${({ containerPadding }) => (containerPadding ? '24px' : '')};
    padding-right: ${({ containerPadding }) =>
        containerPadding ? '24px' : ''};

    ${media.phone`
        padding-top: 28px;
        padding-bottom: 0px;
        font-size: ${(props) => (props.tamanho === 'Grande' ? '32px' : '24px')};
        line-height: 38px;
        margin-bottom: 15px;
        width: ${({ length }) => (length === 2 ? '272px' : '100%')};
        line-height: ${({ length }) => (length === 2 ? '31.2px' : '72.4px%')};
    `}
`

export const Sorriso = styled.div`
    width: 100%;
    height: 30px;
    background-image: ${(props) =>
        props.dark
            ? `url("/parcerias/assets/img-simplifique2.png")`
            : `url("/parcerias/assets/img-simplifique.png")`};
    background-repeat: no-repeat;
    background-position-x: center;
    margin-bottom: 20px;

    ${media.phone`
        margin-bottom: 22px;
    `}
`

export const DescricaoContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
`

export const Descricao = styled.div`
    width: 100%;
    max-width: ${(props) =>
        props.tamanho === 'Grande' || props.tamanho === 'Grande (padrão)'
            ? '850px'
            : '650px'};
    color: #24206b;
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    padding-top: ${(props) =>
        props.tamanho === 'Grande' || props.tamanho === 'Grande (padrão)'
            ? '16px'
            : '0'};

    ${media.phone`
        font-size: 16px;
        line-height: 21px;
        padding: 0px 24px 0px 24px;
    `}

    + * {
        ${media.phone`
            margin-top: 12px;
            margin-bottom: 0;
        `}
        ${media.large`
            margin-top: 32px;
            margin-bottom: 0;
        `}
    }
`
export const Extra = styled.div`
    width: 100%;
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    padding-bottom: ${({ largeWidth }) => (largeWidth ? '0' : '40px')};
    padding-top: 20px;
    max-width: ${({ largeWidth }) => (largeWidth ? '867px' : '646px')};
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    margin-top: 60px;
    margin-bottom: 80px;

    &:last-child {
        padding-bottom: 0;
    }

    hr {
        margin: 24px 0;
        border-color: rgba(17, 14, 73, 0.16);
    }

    ${media.desktop`
       max-width: 700px;
       margin-bottom: 0;
    `}

    ${media.phone`
     margin-bottom: 0;
     margin-top:48px;
     padding-top:0;
      hr{
        margin: 16px 0;
       }
    `}
`

export const ContainerTitulo = styled.div`
    width: 100%;
    max-width: 890px;
    text-align: center;
    padding-bottom: 48px;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
        padding-top: 80px;
        font-weight: normal;

        ${media.phone`
          padding-top: 48px;
        `}
    }

    ${media.large`
        padding: 48px  0;
    `}
     ${media.phone`
        padding: 0px 0 24px 0;
    `}



`
export const BotaoInferior = styled.div`
    margin-top: 47px;
    padding-bottom: ${({ buttonPosition }) => (buttonPosition ? '0' : '56px')};
    margin-bottom: 22px;

    ${media.desktop`
        margin-top: 24px;
        margin-bottom: 19px;

   `}
    ${media.large`
        margin-top: 24px;
        margin-bottom: 0;

    `}
`
